<div class="cookie-banner" [class.cookie-banner--show]="!hasAnswered && bannerInitialized">
    <div class="cookie-banner__content">
      <div class="cookie-banner__header">
        <h3>Cookies & Datenschutz</h3>
        <p>Wir verwenden Cookies, um Ihre Erfahrung auf unserer Website zu verbessern und Ihnen personalisierte Inhalte anzubieten.</p>
      </div>
      
      <div class="cookie-banner__options">
        <div class="cookie-option">
          <div class="cookie-option__header">
            <input type="checkbox" id="necessary" checked disabled>
            <label for="necessary">Notwendig</label>
          </div>
          <p class="cookie-option__description">Für die Grundfunktionen der Website erforderlich.</p>
        </div>
        
        <div class="cookie-option">
          <div class="cookie-option__header">
            <input type="checkbox" id="statistics" (change)="optConsent()" [(ngModel)]="consentSettings.statistics">
            <label for="statistics">Analytik & Statistik</label>
          </div>
          <p class="cookie-option__description">Helfen uns, die Website für Sie zu verbessern.</p>
        </div>
        
        <div class="cookie-option">
          <div class="cookie-option__header">
            <input type="checkbox" id="preferences" (change)="optConsent()" [(ngModel)]="consentSettings.preferences">
            <label for="preferences">Präferenzen</label>
          </div>
          <p class="cookie-option__description">Speichern Ihre Einstellungen für ein besseres Erlebnis.</p>
        </div>
        
        <div class="cookie-option">
          <div class="cookie-option__header">
            <input type="checkbox" id="marketing" (change)="optConsent()" [(ngModel)]="consentSettings.marketing">
            <label for="marketing">Marketing</label>
          </div>
          <p class="cookie-option__description">Verbessern die Relevanz von Werbung für Sie.</p>
        </div>
      </div>
      
      <div class="cookie-banner__actions">
        <button (click)="decline()" class="btn-secondary">Alle ablehnen</button>
        <button *ngIf="showAcceptSelection" (click)="acceptSelected()" class="btn-secondary">Auswahl speichern</button>
        <button (click)="acceptAll()" class="btn-primary">Alle akzeptieren</button>
      </div>
      
      <div class="cookie-banner__footer">
        <a routerLink="/datenschutz" class="cookie-banner__link">Datenschutzerklärung</a>
      </div>
    </div>
  </div>